import React, { useState, useEffect } from "react";
import { BusinessCreditReportStatePII } from "../../../store/businessCreditReportService/types";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const CreditSummaryCommentary: React.FunctionComponent<IProps> = (props) => {
    const [commentaryData, setCommentaryData] = useState({} as any);

    const getCommentary = (key: string) => {
        return (
            <div role="row" className="data-row">
                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                    {commentaryData[key]}
                </div>
            </div>
        );
    };

    const GeneratecCommentaryData = () => {
        if (props.reportObject?.businessCompanyReport?.commentary && Object.keys(props.reportObject?.businessCompanyReport?.commentary).length > 0) {
            let cData: any = props.reportObject?.businessCompanyReport?.commentary;
            let newData: any = {};
            Object.keys(cData).forEach((key: any) => {
                if (cData[key] && cData[key].trim() !== "--") {
                    newData[key] = cData[key];
                }
            });
            setCommentaryData(newData);
        }
    };

    useEffect(() => {
        GeneratecCommentaryData();
    }, []);

    return (
        <React.Fragment>
            {Object.keys(commentaryData).length > 0 && (
                <React.Fragment>
                    <h5 className="inner-title margin-vertical-xs">Commentary</h5>
                    <div role="grid" className="data-grid has-lines row-height-lg">
                        {Object.keys(commentaryData).map((key: string) => (
                            <React.Fragment key={`key-${key}`}>{getCommentary(key)}</React.Fragment>
                        ))}
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default CreditSummaryCommentary;
